export default "__VITE_ASSET__DzyG0$56__"